import api from "../api";

const spaceShowService = {
  // Get space details (matches backend /api/spaces/show/:propertyId)
  getSpaceDetails: async (spaceId) => {
    return await api.get(`/spaces/show/${spaceId}`);
  },

  // Get viewing info for the current user (matches backend /api/spaces/available-info/:userId)
  getViewingInfo: async (spaceId) => {
    return await api.get(`/spaces/keep-me-inform`);
  },

  // Get confirmations for the current user (matches backend /api/spaces/my-confirmations)
  getConfirmations: async (spaceId) => {
    return await api.get(`/spaces/my-confirmations`);
  },

  // Request viewing (matches backend /api/spaces/request-viewing/:propertyId)
  requestViewing: async (spaceId, data) => {
    return await api.post(`/spaces/request-viewing/${spaceId}`, data);
  },

  // Keep informed (matches backend /api/spaces/keep-me-inform/:propertyId)
  keepInformed: async (spaceId) => {
    return await api.post(`/spaces/keep-me-inform/${spaceId}`);
  },

  // Get property viewing info
  getPropertyViewingInfo: async (spaceId) => {
    return await api.get(`/property_viewings/keep_informed/${spaceId}`);
  },

  // Get available spaces search data
  getSearchData: async () => {
    return await api.get("/spaces/search-data");
  },
};

export default spaceShowService;
